export default "__VITE_ASSET__B8fI9HY___"